import React from 'react';
import { useTheme } from '../theme/ThemeContext';

const timelineItems = [
    {
        date: '2026 — 2027',
        title: 'B.Sc. Software Development',
        subtitle: 'Specialization: Applied AI & Scalable Systems',
        details: [
            'Applied AI & ML: reinforcement learning, classification, regression, DNNs, CNNs',
            'Microservices & load balancing: Docker, Kubernetes, Nginx, AWS, Heroku, CI/CD pipelines',
            'Scalability: indexing strategies, query optimization, read-replicas, sharding, distributed architecture',
            'Graph databases, document databases, denormalization — choosing the right tool for the data shape',
            'Software quality: unit, integration, e2e, API, stress/performance, user acceptance testing.',
        ],
    },
    {
        date: '2021 — 2026',
        title: 'Full-Stack Developer — Voonix.net',
        subtitle: 'Data-intensive platform engineering',
        details: [
            'Designed and maintained web scraping pipelines ingesting thousands of data points daily',
            'Built a data validation system that reduced manual QA workload by ~60% through rule-based anomaly detection',
            'Developed internal Scrum tooling with real-time visualization of sprint metrics',
            'Optimized database query patterns and indexing for dashboards serving aggregated statistics',
            'Managed CPanel-based deployment infrastructure and cron-based scheduled jobs',
        ],
    },
    {
        date: '2018 — 2021',
        title: 'Computer Science AP Degree',
        subtitle: 'KEA Copenhagen School of Design & Technology',
        details: [
            'System design & integration: CI/CD with Docker, AWS, Heroku, Jenkins',
            'Design principles: DRY, KISS, SOLID, GRASP — applied, not memorized',
            'Agile development: Scrum, XP, pair programming in team projects',
            'Full-stack Node.js & advanced Python 3 with data science focus',
            'Advanced networking, protocols, GDPR compliance, SaaS/IaaS/PaaS architecture',
        ],
    },
    {
        date: '2016 — 2019',
        title: 'Customer Service Coordinator — Simply.com',
        subtitle: 'DNS & web hosting infrastructure · part-time alongside studies',
        details: [
            'Provided DNS administration and domain management consulting for business clients',
            'Diagnosed and restored hacked WordPress, Joomla, Prestashop, and Umbraco sites',
            'Managed legacy server migrations and data restoration operations',
            'Handled GDPR compliance requests and payment/bookkeeping reconciliation',
            'Built a foundation in distributed systems through DNS and global load-balancing exposure',
        ],
    },
    {
        date: '2014 — 2016',
        title: 'Web Integration Education',
        subtitle: 'Foundation in full-stack web development',
        details: [
            'Web development & integration with PHP, C# ASP.NET, Umbraco CMS',
            'UI/UX fundamentals, MySQL database design, networking & server administration',
            'Innovation & entrepreneurship methodology applied to e-commerce',
        ],
    },
];

function Career() {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <section className="section" id="career">
            <div className="container">
                <div className="section-header reveal">
                    <span className="section-label">{isDark ? '# 02. TIMELINE' : '02 — Experience'}</span>
                    <h2 className="section-header__title">{isDark ? 'Career Trajectory' : 'Experience'}</h2>
                    <p className="section-header__subtitle">
                        From infrastructure operations to AI systems — each phase built
                        architectural intuition for the next.
                    </p>
                </div>

                <div className="timeline">
                    {timelineItems.map((item, idx) => (
                        <div
                            key={item.date}
                            className={`timeline-item reveal reveal-delay-${idx + 1}`}
                        >
                            <p className="timeline-item__date">{item.date}</p>
                            <h3 className="timeline-item__title">{item.title}</h3>
                            <p className="timeline-item__subtitle">{item.subtitle}</p>
                            <ul className="timeline-item__details">
                                {item.details.map((detail) => (
                                    <li key={detail}>{detail}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Career;